import { useCallback, useState } from 'react';

const DEFAULT_PAGE_SIZE = 20;

export function usePagination(size: number = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(0);

  const resetPage = useCallback(() => setPage(0), []);

  return { page, size, setPage, resetPage };
}

export function paginateArray<T>(items: T[], page: number, size: number): T[] {
  return items.slice(page * size, page * size + size);
}
